import { render, staticRenderFns } from "./HuchaTransferirCuentaStep3.vue?vue&type=template&id=d396be2e"
import script from "./HuchaTransferirCuentaStep3.vue?vue&type=script&lang=js"
export * from "./HuchaTransferirCuentaStep3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports